"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownState = void 0;
const mobx_1 = require("mobx");
class DropdownState {
    constructor(dataSource, query) {
        this.initialize = (query) => __awaiter(this, void 0, void 0, function* () {
            const options = yield this.dataSource.get(query);
            mobx_1.runInAction(() => {
                this.options = options;
            });
        });
        this.dataSource = dataSource;
        this.options = [];
        this.search = query === null || query === void 0 ? void 0 : query.search;
        this.enableGroupSearch = query === null || query === void 0 ? void 0 : query.enableGroupSearch;
        this.sort = query === null || query === void 0 ? void 0 : query.sort;
        this.initialize(this.query);
    }
    get query() {
        return {
            search: this.search,
            enableGroupSearch: this.enableGroupSearch,
            sort: this.sort,
        };
    }
    onSearchChange(search) {
        return __awaiter(this, void 0, void 0, function* () {
            this.search = search;
            const options = yield this.dataSource.get(this.query);
            mobx_1.runInAction(() => {
                this.options = options;
            });
        });
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], DropdownState.prototype, "options", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], DropdownState.prototype, "search", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DropdownState.prototype, "query", null);
__decorate([
    mobx_1.action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], DropdownState.prototype, "onSearchChange", null);
exports.DropdownState = DropdownState;
//# sourceMappingURL=dropdown-state.js.map